import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Heading,
  HStack,
  FormControl,
} from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import CodesetSelectWithFilters from "./CodesetSelectWithFilters";
const AmountsEditor = ({
  amounts = [],
  onChange,
  defaultType = "",
  defaultUnitCode = "",
  defaultCcy = null,
  filter = null,
  size = "md",
}) => {
  const [localAmounts, setLocalAmounts] = useState(amounts);

  useEffect(() => {
    setLocalAmounts(amounts);
  }, [amounts]);

  const handleChange = (index, field, value) => {
    const updated = [...localAmounts];
    updated[index][field] = value;
    setLocalAmounts(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const newAmount = {
      type: defaultType,
      unitCode: "",
      ccy: defaultCcy,
      value: 0,
      description: "",
    };
    const updated = [...localAmounts, newAmount];
    setLocalAmounts(updated);
    onChange(updated);
  };

  const handleDelete = (index) => {
    const updated = [...localAmounts];
    updated.splice(index, 1);
    setLocalAmounts(updated);
    onChange(updated);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} borderColor="gray.500">
      <HStack mb={3} justifyContent="flex-start">
        <Heading size={size}>Amounts</Heading>
        <IconButton icon={<HiOutlinePlus />} size={size} onClick={handleAdd} />
      </HStack>

      <Table variant="simple" size={size}>
        <Thead>
          <Tr>
            <Th fontSize={size}>Type</Th>
            <Th fontSize={size}>Unit</Th>
            <Th fontSize={size}>Currency</Th>
            <Th fontSize={size}>Value</Th>
            <Th fontSize={size}>Description</Th>
            <Th fontSize={size}></Th>
          </Tr>
        </Thead>
        <Tbody>
          {localAmounts.map((amt, idx) => (
            <Tr key={idx}>
              <Td>
                <CodesetSelectWithFilters
                  codesetCode="T05"
                  // If filter is provided, pass it to CodesetSelect
                  filter={filter ? filter : null}
                  value={amt.type ? { code: amt.type, description: "" } : null}
                  
                  onChange={(val) => {
                    handleChange(idx, "type", val.code);
                    handleChange(idx, "unitCode", val.unitCode);

                  }}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="6411"
                  // If filter is provided, pass it to CodesetSelect
                  filter={filter ? filter : null}
                  value={amt.unitCode ? { code: amt.unitCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "unitCode", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <FormControl>
                    <Input
                        size={size}
                        height="32px"
                        value={amt.ccy}
                        onChange={(e) => handleChange(idx, "ccy", e.target.value)}
                        placeholder="Currency"
                    />
                </FormControl>
              </Td>
              <Td>
                <Input
                  type="number"
                  step="any"
                  size={size}
                  height="32px"
                  value={amt.value}
                  onChange={(e) => handleChange(idx, "value", parseFloat(e.target.value) || 0)}
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={amt.description}
                  onChange={(e) => handleChange(idx, "description", e.target.value)}
                />
              </Td>
              <Td>
                <IconButton
                  icon={<HiOutlineTrash />}
                  size={size}
                  onClick={() => handleDelete(idx)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default AmountsEditor;
